module.exports = __webpack_public_path__ + "img/pan.d0787677.svg";